import { Typography, Box, Container } from '@mui/material';
import ResponsiveAppBar from './ResponsiveAppBar';
import Contactform from './Contactform';
import { HashLink } from 'react-router-hash-link';
import Footer from "./Footer";
import '../App.css';

const Imprint = () => {
  return (
    <div className="App">

      <ResponsiveAppBar />

      <main>

        <Container maxWidth="lg" className="container subPageContainer">
         
        <HashLink className='breadcrumb' smooth to="/blog">Blog</HashLink>
          <Typography variant='h1' className='sectionTitle'>Was ist eine Baulast und warum ist sie wichtig?</Typography>
           <Typography variant='body1' className='sectionText small'>Martin Konstantin Thelen - 21.08.2026</Typography><br/>


           <Typography variant='h2' className='sectionTitle3 marginTop'>1. Ausgangslage</Typography>
           <Typography variant='body1' className='sectionText'>
           Häufig wollen Eltern eine ihnen gehörende Immobilie zu Lebzeiten auf eines von mehreren Kindern übertragen. Den Übertragungsvertrag muss ein Notar beurkunden. In der Praxis kommen vor allem die folgenden beiden Gestaltungswege vor:
          </Typography>
          <Typography variant='body1' className='sectionText'>
          <b>a)</b> Die Eltern schenken dem Kind die Immobilie gegen Vorbehalt eines Nutzungsrechts. Das Kind braucht kein Geld an die Eltern zu zahlen. Die Eltern haben über das Nutzungsrecht weiter Zugriff auf die Immobilie. Wenn sich die Eltern einen Nießbrauch vorbehalten, dürfen sie selbst kostenlos in der Immobilie wohnen oder diese vermieten. Die Mieterträge stehen den Eltern zu.
          </Typography>
          <Typography variant='body1' className='sectionText'>
          <b>b)</b> Die Eltern verkaufen dem Kind die Immobilie. Im Gegenzug muss das Kind den Kaufpreis in monatlichen Raten an die Eltern zahlen (sog. Verkäuferdarlehen). Das Kind vermietet sodann die Immobilie an die Eltern. Infolgedessen müssen die Eltern monatliche Mietzahlungen an das Kind leisten. Damit haben die Eltern einen monatlichen Zahlungsanspruch gegen das Kind (Darlehen) und das Kind hat seinerseits einen monatlichen Zahlungsanspruch gegen die Eltern (Miete). Soweit sich die Zahlungsansprüche decken, können die Beteiligten sie gegeneinander aufrechnen. Es fließt dann gar kein Geld. Das Kind braucht insoweit keine Finanzierung bei einer Bank aufzunehmen. 
          </Typography>

          <Typography variant='h2' className='sectionTitle3 marginTop'>2. Vor- und Nachteile </Typography>
          <Typography variant='body1' className='sectionText'>
          Beide Gestaltungswege haben verschiedene erbrechtliche, sozialrechtliche und steuerliche Vor- und Nachteile, die die Beteiligten abwägen müssen. Die nachfolgende Tabelle stellt sie überblicksartig dar. In jedem Fall sollten sich die Beteiligten dazu von einem Notar und Steuerberater beraten lassen.
          </Typography>




          <table className="comparison-table">
      <thead>
        <tr>
          <th></th>
          <th>Übertragung mit Nießbrauch</th>
          <th>Verkauf gegen Zahlung in Raten</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className="label"><b>Verteilung der Nutzungen, Kosten und Lasten der Immobilie</b></td>
          <td>
          Die Eltern behalten wirtschaftlich den Zugriff auf die Immobilie. Sie ziehen die Mieten, sind aber auch für alle Kosten und Lasten verantwortlich. Fällt ein Mieter aus, tragen sie das Risiko.
          </td>
          <td>
          Das Kind zieht alle Nutzungen aus der Immobilie. Es trägt auch alle Kosten und Lasten. Es ist selbst Vermieter und muss sich um die Erträge kümmern.
          </td>
        </tr>

        <tr>
          <td className="label"><b>Absicherung der Eltern</b></td>
          <td>
          Durch den Nießbrauch und ein zusätzliches Rückforderungsrecht sind die Eltern davor geschützt, dass ein Gläubiger, Insolvenzverwalter oder Betreuer des Kindes auf die Immobilie zugreifen will.
          </td>
          <td>
          Die Eltern haben nur einen einfachen Mietvertrag mit dem Kind. Ein Gläubiger, Insolvenzverwalter oder Betreuer des Kindes wird den Mietvertrag wahrscheinlich beenden. Dann stehen die Eltern auf der Straße. Sie sollten sich daher durch ein Wohnungsrecht zum Mietvertrag absichern. Zur Absicherung des Darlehens können sie zusätzlich eine Hypothek ins Grundbuch eintragen lassen. 
          </td>
        </tr>

        <tr>
          <td className="label"><b>Zugriff des Sozialamtes</b></td>
          <td>
          Nach Ablauf von zehn Jahren ab der Schenkung kann das Sozialamt nicht mehr verlangen, dass die Eltern die Immobilie für ihre Pflegekosten einsetzen. 
          </td>
          <td>
          Wenn der Erwerber einen Kaufpreis für den vollen Wert der Immobilie tatsächlich bezahlt, handelt es sich nicht um eine Schenkung. Infolgedessen kann das Sozialamt nicht auf die Immobilie zugreifen. Es greift auf das gesamter Geldvermögen der Eltern zu.
          </td>
        </tr>



        <tr>
          <td className="label"><b>Pflichtteilsansprüche eines anderen Kindes</b></td>
          <td>
          Ein weiteres Kind der Eltern kann ggf. wegen der Schenkung einen Pflichtteilsanspruch geltend machen. Der Wert des Nießbrauchs wird meist vom Wert der Schenkung abgezogen.  
          </td>
          <td>
          Wenn der Erwerber einen Kaufpreis für den vollen Wert der Immobilie tatsächlich bezahlt bzw. mit der Miete verrechnet, handelt es sich nicht um eine Schenkung. Das enterbte Kind kann nur bzgl. des vorhandenen Geldvermögens der Eltern den Pflichtteil geltend machen.
          </td>
        </tr>
        <tr>
          <td className="label"><b>Grunderwerbsteuer</b></td>
          <td colspan="2">
          Fällt nicht an, wenn Eltern Immobilieneigentum auf ein Kind übertragen, § 3 Nr. 6 GrEStG. 
          </td>
        </tr>
        <tr>
          <td className="label"><b>Schenkungs- und Erbschaftssteuer</b></td>
          <td>
          Der sog. Kapitalwert des Nießbrauchs wird vom Wert der Schenkung abgezogen. Je jünger der Schenker ist, desto höher ist der Kapitalwert des Nießbrauchs und desto weniger Schenkungsteuer fällt an. Zudem hat jedes Kind pro Elternteil einen Freibetrag von 400.000 Euro alle zehn Jahre. 
          </td>
          <td>
          Soweit der Käufer den Kaufpreis tatsächlich zahlt, ist es keine Schenkung. Nur soweit das Kind nichts für den Erhalt der Immobilie zahlt oder die Zahlungspflicht nachträglich entfällt (etwa wegen Versterbens der Eltern), kann Schenkungsteuer anfallen. 
          </td>
        </tr>
        <tr>
          <td className="label"><b>Einkommenssteuer</b></td>
          <td>
          Der Nießbraucher muss die Mieteinnahmen als Einkommen versteuern. Er kann Aufwendungen für Abschreibungen (AfA) fortführen. Der Beschenkte zahlt insoweit keine Einkommensteuer, weil er keine Einnahmen hat.
          </td>
          <td>
          Der Verkäufer muss ggf. Einkommensteuer auf die Raten und Zinsen zahlen. Der Käufer kann die Zahlungen der Raten und Zinsen als Betriebsausgaben oder alternativ als Werbungskosten geltend machen. Außerdem müsse alle Parteien auf die 10-Jahres-Frist für sog. Spekulationsgeschäfte achten. 
          </td>
        </tr>



      </tbody>
    </table>







        </Container>


        <Box className="section bannergrey" id="kontakt">
                                <Container maxWidth="lg" className="container" id="kontakt">
                                    <Box className="kontaktGrid">
                                        <Box className="kontaktLeftSide smaller">
                                            <Typography variant='h2' className='sectionTitle white small'>
                                                Sie haben Fragen?  <br />
                                                Wir stehen Ihnen gerne zur Verfügung und beantworten Ihr Anliegen in Kürze.
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>Öffnungszeiten</b><br />
                                                Montag bis Freitag von 8:00 bis 13:00 Uhr und 14:00 bis 17:00 Uhr<br />
                                                Mittwoch ab 13:00 Uhr geschlossen<br />
                                                Spätere Termine sind nach Vereinbarung möglich<br />
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>Telefon</b><br />
                                                Sie erreichen uns unter: 02241 66444<br />
                                                Montag bis Freitag von 9:00 bis 13:00 Uhr und 14:00 bis 17:00 Uhr<br />
                                                Mittwoch nur bis 13:00 Uhr. <br />
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>E-mail: info@ht-notare.de</b><br />
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>Fax: 02241 55161</b><br />
                                            </Typography>
                                            <Typography variant='body1' paragraph className='whiteText smaller'>
                                                <b>Anfahrt und Parkmöglichkeiten</b><br />
                                                Das Büro befindet sich im Zentrum von Siegburg im Geschäftshaus Am Brauhof 2. Die Kanzleiräume liegen in der ersten Etage und sind mittels eines Aufzugs und Treppenlifts barrierefrei zugängig. Im Parkzentrum Holzgasse (Scheerengasse 5, 53721 Siegburg) können Sie die mit „HT Notare“ markierten Stellplätze 17a, 20, 27 und 29 kostenfrei nutzen. Diese erreichen Sie, indem Sie nach der Einfahrt in die Tiefgarage rechts abbiegen und dann in dieser Richtung bis zum Ende der Garage durchfahren. Hierbei passieren Sie eine rot leuchtende Ampel. Von den Stellplätzen aus gelangen Sie durch eine eigene Tür mit Klingelschild in das Treppenhaus und zum Lift. Weitere (kostenpflichtige) Parkmöglichkeiten befinden sich im Parkhaus von Galeria Kaufhof und Saturn, etwa 100 Meter entfernt liegend vom Büro.
                                            </Typography>
                                        </Box>
                                        <Contactform />
                                    </Box>
                                </Container>
                            </Box>

      </main >
      <Footer />
    </div >
  );
}

export default Imprint;